import { initializeAxiosBaseQuery } from '@gasbi/shared/common/utils/axiosBaseQuery';

import http from '@/utils/http';

const fabric = initializeAxiosBaseQuery(http);

// A relative baseUrl ('/api/...') would be APPENDED to the axios instance's own
// '/api' baseURL, producing /api/api/... - absolutize it so it replaces the
// instance baseURL exactly like the old absolute VITE_API_URL did.
const toAbsolute = (url: string) =>
  url.startsWith('/') ? window.location.origin + url : url;

const axiosBaseQuery = (options: Parameters<typeof fabric>[0]) =>
  fabric({ ...options, baseUrl: toAbsolute(options.baseUrl) });

export default axiosBaseQuery;
